export const Patterns = {
  // password: '',
  name: '^[a-zA-Z\\u0590-\\u05FF\\s]{1,128}', // Letters and spaces only, max 128
  mobile: '^(\\+\\s?)?((?<!\\+.*)\\(\\+?\\d+([\\s\\-\\.]?\\d+)?\\)|\\d+)([\\s\\-\\.]?(\\(\\d+([\\s\\-\\.]?\\d+)?\\)|\\d+))*(\\s?(x|ext\\.?)\\s?\\d+)?$',
}
